import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import {
  ApproveSupplierData,
  ViewApproverGrnData,
} from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SystemAlert from "../../components/common/SystemAlert";
import FilterGrnSearch from "../../components/grn/FilterGrnSearch";
import FilterSupplierSearch from "../../components/supplier/FilterSupplierSearch";
function ViewApproveSuppliers() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);

  useEffect(() => {
    setPageData({
      title: "Supplier Account Management",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const [filteredRows, setFilteredRows] = useState(ApproveSupplierData.rows);

  const handleItemClick = (id, actionText) => {
    navigate("/ApproveSupplier", {
      state: {
        origin: "ViewApprover",
        status: [
          { step: "Approver", status: "Submit" },
          { step: "Manager", status: "Reject" },
        ],
      },
    });
    // if (actionText === "Edit") {
    //   const selectedItem = data.find((item) => item.MENUCODE === id);
    //   if (selectedItem) {
    //     const stringifiedItem = Object.fromEntries(
    //       Object.entries(selectedItem).map(([key, value]) => [
    //         key,
    //         String(value),
    //       ])
    //     );
    //     navigate(`/AddItem`, {
    //       state: { selectedItem: stringifiedItem, actionText },
    //     });
    //   }
    // } else {
    //   navigate(`/AddItem`, { state: { selectedItem: "" } });
    // }
  };

  const menuItems = [
    {
      text: "View",
      icon: <VisibilityOutlinedIcon />,
      onClick: (MENUCODE) => handleItemClick(MENUCODE, "View"),
    },
  ];
  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Supplier
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            Supplier Account Management
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ApproveSupplierData.name}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}></Grid>
            {/* <Grid
              item
              size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}
              sx={styles.vg_grid_new_button}
            >
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={goToCreateGrn}
              >
                New
              </Button>
            </Grid> */}
          </Grid>
        </AppBar>
        <FilterSupplierSearch />

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={ApproveSupplierData.columns}
            // rows={rows}
            rows={filteredRows.map((item) => ({ ...item, id: item.field }))}
            menuItems={menuItems}
            tabletitle={ApproveSupplierData.name}
            gridid="field"
            sx={styles.view_data_grid_page}
            // onSelectionChange={handleRowSelection}
          />
        </Box>
      </Box>
    </>
  );
}

export default ViewApproveSuppliers;
